var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#BDD5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.955 15.384c0 3.475-2.73 6.292-6.1 6.292-3.368 0-6.099-2.817-6.099-6.292 0-3.475 2.731-6.292 6.1-6.292 3.368 0 6.1 2.817 6.1 6.292zM12.182 29.814c0-3.476 2.73-6.293 6.1-6.293h9.148c3.37 0 6.1 2.817 6.1 6.293 0 3.475-2.73 6.292-6.1 6.292h-9.149c-3.368 0-6.1-2.817-6.1-6.293z",
    fill: "#1175D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePeople);
export default __webpack_public_path__ + "static/media/homePeople.248201f1ecdd8f6eb73e2beead5a6afa.svg";
export { ForwardRef as ReactComponent };